import * as React from 'react';
import { CheckPermissions } from './Shared';
import { useNavigate } from 'react-router-dom';

const ReportPrepaidInvoicesSentData = () => {
    let navigate = useNavigate();
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [date, setDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const handleDateChange = (e: any) => {
        let errorList = errors;
        delete errorList["date"];
        setErrors(errorList);
        setDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!date) {
            formIsValid = false;
            errorList["date"] = "Date is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            runRpt();
        }
    }

    const runRpt = async () => {
        var url = "/report/PrepaidInvoicesSentReport/" + date + "/-1/-1/-1/-1";
        window.open(url, '_blank');
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Prepaid Invoices Sent To Reckon</h1>
            </div>
            <div className="marginTop20">
                <span>Gets a list of all prepaid customer invoices sent to Reckon for the selected date.</span>
            </div>
            <div>
                <label className="input-group" htmlFor="date">
                    <span className="label">Date</span>
                    <input type='date' id="date" name="date" className='input' value={date} onChange={(e) => handleDateChange(e)}></input>
                </label>
                <span className={errors["date"] ? "label errors marginLeftLabel" : "hidden"}>{errors["date"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportPrepaidInvoicesSentData;